import { render, staticRenderFns } from "./VMessage.vue?vue&type=template&id=0c7484e3"
import script from "./VMessage.vue?vue&type=script&lang=js"
export * from "./VMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports